import React from "react";
import { motion } from "framer-motion";
import { Baby, Heart, Droplets, Sparkles } from "lucide-react";

const services = [
  {
    icon: Baby,
    title: "Neugeborenen­kontrollen",
    items: [
      "Regelmässige Gewichtskontrollen",
      "Beobachtung der Entwicklung",
      "Neugeborenenscreening (Guthrie-Test)",
      "Blutentnahmen bei Gelbsucht",
    ],
    testid: "service-neugeborenenkontrollen",
  },
  {
    icon: Heart,
    title: "Kontrolle bei der Mutter",
    items: [
      "Rückbildungskontrollen",
      "Wundkontrollen",
      "Persönliche Beratung bei Fragen",
      "Begleitung in der Erholungsphase",
    ],
    testid: "service-mutterkontrollen",
  },
  {
    icon: Droplets,
    title: "Ernährung",
    items: [
      "Begleitung beim Stillen",
      "Unterstützung bei der Flaschenernährung",
      "Individuell auf dich abgestimmt",
      "Hilfe bei Stillproblemen",
    ],
    testid: "service-ernaehrung",
  },
  {
    icon: Sparkles,
    title: "Instruktionen",
    items: [
      "Anleitung beim Babybaden",
      "Binden des Tragetuchs",
      "Umgang mit Tragehilfen",
      "Sicheres & entwicklungsförderndes Handling",
    ],
    testid: "service-instruktionen",
  },
];

export default function Services() {
  return (
    <section id="leistungen" className="relative py-24 sm:py-32 bg-[#F4EFE6] grain" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 relative">
        <div className="max-w-3xl mb-16 sm:mb-24">
          <p className="text-sm sm:text-base tracking-[0.25em] uppercase text-[#A66B56] font-semibold mb-6">Meine Leistungen</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#2A332C] leading-[1.05]">
            <span className="font-display-italic text-[#A66B56]">kompetent</span> begleitet.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              className="bg-[#FDFBF7] rounded-[2rem] p-8 sm:p-10 border border-white/60 shadow-sm hover:-translate-y-1 transition-transform duration-300"
              data-testid={s.testid}
            >
              <div className="w-14 h-14 rounded-full bg-[#EBE3D5] flex items-center justify-center mb-8">
                <s.icon className="w-6 h-6 text-[#5C6B5E]" strokeWidth={1.5} />
              </div>
              <h3 className="font-display text-3xl text-[#2A332C] mb-4 leading-tight">{s.title}</h3>
              <ul className="space-y-2 text-[#5C6B5E] leading-relaxed">
                {s.items.map((item) => (
                  <li key={item} className="flex items-start gap-2">
                    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#A66B56] flex-shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
